import { Separator } from "@radix-ui/react-separator"
import * as React from "react"

import clsxm from "@/lib/clsxm"

type DividerProps = {
  orientation: `vertical` | `horizontal`
  flexChild?: boolean
  thickness: 1 | 2 | 4
} & React.ComponentPropsWithRef<`div`>

export function Divider({
  orientation,
  flexChild,
  thickness,
  className,
  ...rest
}: DividerProps) {
  return (
    <Separator
      {...rest}
      className={clsxm(
        [
          flexChild && [`self-stretch`],

          orientation === `vertical` && [
            `border-r border-gray-200`,
            thickness === 1 && [`w-px`],
            thickness === 2 && [`w-0.5`],
            thickness === 4 && [`w-1`],
          ],

          orientation === `horizontal` && [
            `border-b border-gray-200`,
            thickness === 1 && [`h-px`],
            thickness === 2 && [`h-0.5`],
            thickness === 4 && [`h-1`],
          ],
        ],
        className
      )}
      orientation={orientation}
    />
  )
}
